import React from 'react';
import DecisionModeWidget from './DecisionModeWidget';

const GetNIcpModal = ({ isOpen, onClose, userICP = 0 }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="get-nicp-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <div className="modal-title">
            <span className="modal-icon">💧</span>
            <h2>Get nICP</h2>
          </div>
          <button className="modal-close" onClick={onClose}>
            ✕
          </button>
        </div>
        
        <div className="modal-body">
          <DecisionModeWidget onClose={onClose} userICP={userICP} />
        </div>
      </div>
    </div>
  );
};

export default GetNIcpModal;
